export default __webpack_public_path__ + "static/futbol-sites-5a3d3ab4489d3cc8e085136df03e132d.svg";